/* eslint-disable */

/** unique or primary key constraints on table "argo.acl" */
export enum ArgoAclConstraint {
  /** unique or primary key constraint on columns "acl_id" */
  AclPkey = 'acl_pkey'
}

/** select columns of table "argo.acl" */
export enum ArgoAclSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.acl" */
export enum ArgoAclUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

